import { ProductsService } from "./../../../../services/products.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidatorFn
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { AppConfig } from "../../../../app.config";
import { MessageService } from "primeng/api";
import { RegistrationService } from "../../../../services/registration.service";
import { UserService } from "../../../../services/user.service";
import { PartnerService } from "../../../../services/partner.service";
import { HelpersService } from "../../../../services/helpers.service";
import { AddEditUserComponent } from "../../../modals/add-edit-user/add-edit-user.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
@Component({
  selector: "app-wizard-users",
  templateUrl: "./wizard-users.component.html",
  styleUrls: ["./wizard-users.component.scss"]
})
export class WizardUsersComponent implements OnInit {
  @Input() messageService: MessageService;
  @Input() partner;
  @Input() verificationCode;
  @Output() next = new EventEmitter();

  public creatingDummyData: boolean = false;
  public techniciansName: any = [];
  public errorText: string = "";
  public techniciansNumber: number;
  public usersLoading = true;
  public users: any = [];
  public technicians: any = [];
  public hasTechnician = false;
  public userMetrics: any = {
    userTotal: 0,
    adminCount: 0,
    technicianCount: 0
  };
  public workshopSelected: boolean = true;

  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private translate: TranslateService,
    private registrationService: RegistrationService,
    private partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    public router: Router,
    private productsService: ProductsService,
    public userService: UserService
  ) { }

  change(e) {
    this.techniciansNumber = e;
    let techniciansNumber;
    if (e > 10) {
      techniciansNumber = 10;
      this.errorText = "Max number of technicians is 10*";
    } else if (e < 1) {
      techniciansNumber = 1;
      this.errorText = "Min number of technicians is 1*";
    } else {
      techniciansNumber = e;
      this.errorText = "";
    }
    let temp = [];
    for (let i = 0; i < techniciansNumber; i++) {
      temp.push("");
    }
    this.techniciansName = temp;
  }

  indexTracker(index: number, value: any) {
    return index;
  }

  ngOnInit() {
    if (!this.partner || !this.partner.PartnerID) {
      this.registrationService.verifyAccount(this.verificationCode).subscribe(
        partner => {
          this.partner = partner;

          if (!(this.partner.SubscribedProducts && this.partner.SubscribedProducts.length > 0 && this.partner.SubscribedProducts.filter(x => { return x.productType === 'WORKSHOP' }).length > 0)) {
            this.workshopSelected = false;
          }

          this.productsService
            .getAllProducts(this.partner.PartnerID)
            .subscribe(products => {
              console.log(products);
              this.helpersService.saveProductData(products);
            });
          this.getUsers();
        },
        err => {
          this.usersLoading = false;
        }
      );
    } else {
      if (!(this.partner.SubscribedProducts && this.partner.SubscribedProducts.length > 0 && this.partner.SubscribedProducts.filter(x => { return x.productType === 'WORKSHOP' }).length > 0)) {
        this.workshopSelected = false;
      }
      this.productsService
        .getAllProducts(this.partner.PartnerID)
        .subscribe(products => {
          this.helpersService.saveProductData(products);
        });
      this.getUsers();
    }
  }

  goNext() {
    if (this.workshopSelected) {
      this.userService
        .registerTechnicians({
          Names: this.techniciansName,
          PartnerID: this.partner.PartnerID,
          EmailDomain: this.partner.UserName.split("@")[1]
            ? "@" + this.partner.UserName.split("@")[1]
            : "@bikeShop.co.za"
        })
        .subscribe(newUsers => {
          this.creatingDummyData = true;
          this.registrationService.generateDummyData(this.verificationCode, { PartnerID: this.partner.PartnerID }).subscribe(result => {
            this.creatingDummyData = false;
            this.emitNext();
          }, err => {
            this.creatingDummyData = false;
            this.emitNext();
          });
        }, err => {
          this.creatingDummyData = true;
          this.registrationService.generateDummyData(this.verificationCode, { PartnerID: this.partner.PartnerID }).subscribe(result => {
            this.creatingDummyData = false;
            this.emitNext();
          }, err => {
            this.creatingDummyData = false;
            this.emitNext();
          });
        });
    } else {
      this.emitNext();
    }
  }

  emitNext() {
    if ([-2, -1, 0].indexOf(this.partner.POSSystemID) > -1) {
      this.router.navigateByUrl("/store/calendar");
    } else {
      this.next.emit();
    }
  }

  getUsers() {
    this.usersLoading = true;
    this.partnerService.getPartnerUsers(this.partner.PartnerID).subscribe(
      users => {
        this.getTechnicians(users);
      },
      err => {
        this.usersLoading = false;
      }
    );
  }

  getTechnicians(users) {
    this.partnerService.getPartnerTechnicians(this.partner.PartnerID).subscribe(
      technicians => {
        this.users = users;
        this.technicians = technicians;
        let user_ids = this.users.map(user => {
          return user.ID;
        });
        technicians.forEach(technician => {
          let user = this.users[user_ids.indexOf(technician.UserID)];
          if (
            (technician.IsActive && technician.UserID === 0) ||
            (technician.IsActive && user)
          ) {
            this.hasTechnician = true;
          }
          if (technician.UserID === 0 || !user) {
            technician.Name = technician.Firstname; //Just so the View works...not Ideal but hey :)
            this.users.push(technician);
          } else {
            user.Technician = technician;
          }
        });

        this.userMetrics.adminCount = this.users.filter(x => {
          return x.TechnicianID === 0;
        }).length;
        this.userMetrics.technicianCount = this.users.filter(x => {
          return x.TechnicianID > 0;
        }).length;
        this.userMetrics.userTotal = this.users.length;

        this.users = this.users.sort(function (a, b) {
          if (a.Name < b.Name) return -1;
          if (a.Name > b.Name) return 1;
          return 0;
        });
        this.usersLoading = false;
      },
      err => {
        this.usersLoading = false;
      }
    );
  }

  editUser(user) {
    const modalRef = this.modalService.open(AddEditUserComponent, {
      size: "lg",
      backdrop: "static",
      windowClass: "user-modal"
    });
    modalRef.componentInstance.partnerId = this.partner.PartnerID;
    modalRef.componentInstance.user = user;
    modalRef.componentInstance.users = this.users;
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.componentInstance.update.subscribe(() => {
      this.getUsers();
    });
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.result.then(
      result => {
        this.getUsers();
      },
      onrejected => {
        this.getUsers();
      }
    );
  }

  skipToHubtiger() {
    this.creatingDummyData = true;
    this.registrationService.generateDummyData(this.verificationCode, { PartnerID: this.partner.PartnerID }).subscribe(result => {
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    }, err => {
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    });

  }

  hasTechnicians() {
    var techniciansNumber = this.techniciansNumber > 0;
    var hasNames = this.techniciansName.filter(x => { return x !== "" }).length === this.techniciansNumber;
    return this.hasTechnician || (this.techniciansNumber > 0 && hasNames);
  }
}


